import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import { Slot } from "@radix-ui/react-slot";
import { ActionIcon } from "../../ActionIcon/index.js";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { _ComboboxBadge } from "./ComboboxBadge/index.js";
import { _ as _GenericRoot, s } from "../../../GenericRoot-CGl8hx8Z.js";
import { InputFieldContext } from "./InputFieldContext.js";
const ComboboxRoot = withThemeAndSize(
  forwardRef(({ children, className, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(_GenericRoot, { ...rest, as: "div", ref, className: clsx(s.combobox, className), children });
  })
);
const InputRoot = withThemeAndSize(
  forwardRef(({ children, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(_GenericRoot, { ...rest, as: "label", ref, children });
  })
);
const ButtonRoot = withThemeAndSize(
  forwardRef(({ children, className, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(_GenericRoot, { ...rest, as: "button", ref, className: clsx(s.button, className), children });
  })
);
const Affix = forwardRef(({ className, children, rightIcon, leftIcon, ...rest }, ref) => {
  return /* @__PURE__ */ jsxs("div", { ...rest, className: clsx(s.suffix, className), ref, children: [
    leftIcon && /* @__PURE__ */ jsx(IconWrapper, { className: s.leftIcon, children: leftIcon }),
    children,
    rightIcon && /* @__PURE__ */ jsx(IconWrapper, { className: s.rightIcon, children: rightIcon })
  ] });
});
const ComboboxInputSection = forwardRef(({ className, children, icon, ...rest }, ref) => {
  return /* @__PURE__ */ jsxs("label", { ...rest, className: clsx(s.comboboxInputSection, className), ref, children: [
    children,
    icon && /* @__PURE__ */ jsx(IconWrapper, { className: s.comboboxInputSectionIcon, children: icon })
  ] });
});
const ComboboxCloseButton = forwardRef(({ disabled: disabledFromProps, ...rest }, ref) => {
  const context = useContext(InputFieldContext);
  const disabled = disabledFromProps ?? (context == null ? void 0 : context.disabled);
  return /* @__PURE__ */ jsx(ActionIcon, { ...rest, ref, actionIconType: "ghost", icon: /* @__PURE__ */ jsx(Icons24, { name: "Close" }), disabled });
});
const Input = forwardRef(
  ({ className, label, disabled: disabledFromProps, ...rest }, ref) => {
    const context = useContext(InputFieldContext);
    const disabled = disabledFromProps ?? (context == null ? void 0 : context.disabled);
    const asChild = "asChild" in rest ? rest.asChild : false;
    const Comp = asChild ? Slot : "input";
    return /* @__PURE__ */ jsx(Comp, { ...rest, disabled, className: clsx(s.input, className), ref });
  }
);
const ButtonContent = forwardRef(({ className, children, ...rest }, ref) => {
  return /* @__PURE__ */ jsx("div", { ...rest, className: clsx(s.buttonContent, className), ref, children });
});
InputRoot.displayName = "InputField";
const InputField = Object.assign(InputRoot, {
  Affix,
  Input
});
ComboboxRoot.displayName = "ComboboxField";
const ComboboxField = Object.assign(ComboboxRoot, {
  Badge: _ComboboxBadge,
  CloseButton: ComboboxCloseButton,
  InputSection: ComboboxInputSection,
  Input,
  Affix
});
ButtonRoot.displayName = "ButtonField";
const ButtonField = Object.assign(ButtonRoot, {
  Content: ButtonContent,
  Affix
});
export {
  ButtonField,
  ComboboxField,
  InputField
};
